import {dispatchSnackbar} from "../../../components/SnackBar/snackbar-bus"


export const pasteTableFromClipboard = async (payload, callbackFunction) => {
    try {
        const text = await navigator.clipboard.readText()
        if (!text?.trim()) return

        const rows = text
            .trim()
            .split(/\r?\n/)
            .filter(r => r.trim() !== "")
            .slice(1)

        const keys = payload.map((field) => field.key)
        const data = rows.map(row => {
            const cols = row.split("\t")
            const obj = {}

            cols.forEach((value, index) => {
                const key = keys[index]
                if (key) {
                    obj[key] = value.trim()
                }
            })

            return obj
        })
        console.log(data)
        if (callbackFunction !== null) {
            callbackFunction(data)
        }
    } catch (error) {
        console.error("Erro ao ler clipboard:", error)
    }
}

const CSV_SEPARATOR = ";"
export const escapeCsvValue = (value) => {
    if (value == null) return ""
    const stringValue = String(value)

    if (
        stringValue.includes(CSV_SEPARATOR) ||
        stringValue.includes('"') ||
        stringValue.includes("\n")
    ) {
        return `"${stringValue.replace(/"/g, '""')}"`
    }

    return stringValue
}

export const copyTable = async (tableData, fields) => {
    if (!tableData.length) return

    const headers = fields.map((field) => field.key)
    const csv = [
        headers.join(CSV_SEPARATOR),
        ...tableData.map((row) =>
            headers.map((header) => escapeCsvValue(row[header])).join(CSV_SEPARATOR)
        ),
    ].join("\n")

    try {
        console.log(tableData)
        await navigator.clipboard.writeText(csv)
        dispatchSnackbar("Dados copiados para a área de transferência", "success")
    } catch (error) {
        dispatchSnackbar(`Erro ao copiar a tabela: ${error}`, "error")
    }
}